<template>
  <nav
    class="w3-sidebar w3-pink w3-collapse w3-top w3-large w3-padding"
    :style="{display: visible ? 'block' : 'none' }"
  >
    <div class="locale-container">
      <img src="~@/assets/flag_hu.png" alt="flag hu" @click="$store.commit('setLocale', 'hu')">
      <img src="~@/assets/flag_en.png" alt="flag en" @click="$store.commit('setLocale', 'en')">
      <img src="~@/assets/flag_de.png" alt="flag de" @click="$store.commit('setLocale', 'de')">
    </div>

    <div class="w3-container logo-container">
      <router-link to="/">
        <img :src="`/static/images/logo/logo_${locale}.png`" alt="BeCreative logo">
      </router-link>
    </div>

    <div class="w3-bar-block w3-padding-8 link-container">
      <router-link
        class="w3-bar-item w3-button w3-hover-white"
        to="/rolunk"
      >
        {{ $t('Rólunk') }}
      </router-link>

      <router-link
        class="w3-bar-item w3-button w3-hover-white"
        to="/hireink"
      >
        {{ $t('Híreink') }}
      </router-link>

      <router-link
        class="w3-bar-item w3-button w3-hover-white"
        to="/termekeink"
      >
        {{ $t('Termékeink') }}
      </router-link>

      <router-link
        class="w3-bar-item w3-button w3-hover-white"
        to="/agc"
      >
        AGC
      </router-link>

      <router-link
        class="w3-bar-item w3-button w3-hover-white"
        to="/referenciak"
      >
        {{ $t('Referenciák') }}
      </router-link>

      <router-link
        class="w3-bar-item w3-button w3-hover-white"
        to="/tervezo"
      >
        {{ $t('Tervező') }}
      </router-link>

      <router-link
        class="w3-bar-item w3-button w3-hover-white"
        to="/kapcsolat"
      >
        {{ $t('Kapcsolat') }}
      </router-link>
    </div>

    <div class="w3-right-align foot">
      <p class="w3-small" v-html="$t('Contact text')"></p>

      <a href="https://www.facebook.com/becreative.glass/">
        <img src="~@/assets/facebook.svg" alt="facebook">
      </a>

      <div class="w3-small">
        <router-link
          class="statement-link"
          to="/adatvedelmi-nyilatkozat"
        >
          Adatvédelmi nyilatkozat
        </router-link>
        |
        <router-link
          class="statement-link"
          to="/jogi-nyilatkozat"
        >
          Jogi nyilatkozat
        </router-link>
      </div>
    </div>
  </nav>
</template>

<i18n>
  {
    "de": {
      "Rólunk": "Über uns",
      "Híreink": "Nachrichten",
      "Termékeink": "Unsere Produkte",
      "Referenciák": "Referenzen",
      "Tervező": "Designer",
      "Kapcsolat": "Kontakt",
      "Contact text": "Alexy Üvegtechnika Orosháza Kft.<br>5900 Orosháza, Juhász Gyula u. 5091/1 Pz., Ungarn<br> +36 20 330 0518 • info@becreative.glass"
    },
    "en": {
      "Rólunk": "About us",
      "Híreink": "News",
      "Termékeink": "Our products",
      "Referenciák": "References",
      "Tervező": "Designer",
      "Kapcsolat": "Contact",
      "Contact text": "Alexy Üvegtechnika Orosháza Kft.<br> 5091/1, Juhász Gyula St, Orosháza 5900, Hungary<br> +36 20 330 0518 • info@becreative.glass"
    },
    "hu": {
      "Rólunk": "Rólunk",
      "Híreink": "Híreink",
      "Termékeink": "Termékeink",
      "Referenciák": "Referenciák",
      "Tervező": "Tervező",
      "Kapcsolat": "Kapcsolat",
      "Contact text": "Alexy Üvegtechnika Orosháza Kft.<br> 5900 Orosháza, Juhász Gyula u. 5091/1 hrsz.<br> +36 20 330 0518 • info@becreative.glass"
    }
  }
</i18n>

<script>
  export default {
    name: 'navbar',
    data() {
      return {
        windowWidth: window.innerWidth,
      };
    },
    mounted() {
      window.addEventListener('resize', this.onWindowResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onWindowResize);
    },
    methods: {
      onWindowResize() {
        if (window.innerWidth < 992 && this.windowWidth >= 992) {
          this.closeNav();
        }

        this.windowWidth = window.innerWidth;
      },
      showNav() {
        this.$store.commit('setNavbarVisibility', true);
      },
      closeNav() {
        this.$store.commit('setNavbarVisibility', false);
      },
    },
    computed: {
      visible() {
        return this.$store.state.navbarVisible;
      },
      locale() {
        return this.$store.state.i18n.locale;
      },
    },
    watch: {
      '$route.path': function routePathWatcher() {
        this.closeNav();
      },
    },
  };

</script>

<style scoped>
  nav {
    background-color: #eb2e4a !important;
    z-index: 3;
    width: 300px;
  }

  .link-container {
    height: calc(100% - 189px - 160px);
    min-height: 300px;
  }

  a {
    font-weight: bold;
  }

  .foot img {
    width: 100px;
    margin-bottom: 10px;
  }

  .locale-container {
    text-align: right;
  }

  .locale-container img {
    cursor: pointer;
    user-select: none;
  }

  .logo-container {
    margin: 0 0 32px 0;
  }

  .statement-link {
    text-decoration: none;
    font-weight: normal;
  }

</style>



// WEBPACK FOOTER //
// Navbar.vue?13a02a75